import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'cigna-leave-page-dialog',
  templateUrl: './leave-page-dialog.component.html',
  styleUrls: ['./leave-page-dialog.component.scss'],
})
export class LeavePageDialogComponent {
  constructor(
    public leavePageDialogRef: MatDialogRef<LeavePageDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      heading: string;
      content: string;
    },
  ) {}
}
